import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { useUser } from "~/api/users/hooks/use-user";
import { useCollectTillContext } from "~/routes/__app.collect/collect-till-context";

import { UserInfo } from "./user-info";
import { UserInfoSkeleton } from "./user-info-skeleton";

type UserInfoContainerProps = {
  childId: string;
};

export const UserInfoContainer = ({ childId }: UserInfoContainerProps) => {
  const { data: user, status } = useUser({
    childId
  });

  const { locale, language } = useCurrentTillLocalisation();

  const showUserBalanceAndDailySpendingLimit = useCollectTillContext(
    (till) =>
      till.type === "collect" &&
      till?.config?.showUserBalanceAndDailySpendingLimit &&
      (till.moduleConfig.paymentMethod === "credit" ||
        till.config.collectionModules.some(
          (module) => module.paymentMethod === "credit"
        ))
  );

  const allergens = [
    ...(user?.allergens ?? []),
    ...(user?.allergensCustom ? [user?.allergensCustom] : [])
  ];

  if (status === "pending") {
    return <UserInfoSkeleton />;
  }

  if (!user) {
    return null;
  }

  return (
    <UserInfo
      name={user.name}
      allergens={allergens}
      currency={user.currency}
      languageCode={language}
      locale={locale}
      balance={showUserBalanceAndDailySpendingLimit ? user.balance : null}
      collectLimit={
        showUserBalanceAndDailySpendingLimit ? user.collectLimit : null
      }
      cardIdentifier={user.cardIdentifier}
      childId={childId}
    />
  );
};
